import { CompanyMyInvitationsContent } from "../../features/companyWorkspace";

function CompanyMyInvitationsScreen() {
  return <CompanyMyInvitationsContent />;
}

export default CompanyMyInvitationsScreen;
